import AuthService from 'services/auth-service';
import { sessionMonitor } from './sessionMonitor';

export { sessionMonitor } from './sessionMonitor';
export type { DeathInfo, SessionVerdict } from './sessionMonitor';
export { classifyFailure, isAuthShapedFailure } from './classifyFailure';
export type { FailureContext, Suspicion } from './classifyFailure';
export { installSessionInterceptor } from './installSessionInterceptor';
export { isSessionEvent, scrubSessionEvent } from './scrubSessionEvent';
export { clearLocalSession } from './clearLocalSession';
export type { ClearLocalSessionOptions } from './clearLocalSession';
export { endSession } from './endSession';
export type { LoginLocationState, SessionEndedReason } from './endSession';

// A timer can fire late (a throttled background tab), so the deadline is also
// checked directly.
const isPastExpiry = (): boolean => {
  const expiresAtMs = Date.parse(AuthService.getExpiresAt() || '');
  return !Number.isNaN(expiresAtMs) && expiresAtMs <= Date.now();
};

/** A stored session that the monitor has not judged dead and has not expired. */
export const hasUsableSession = (): boolean =>
  !!AuthService.getAuth() && !sessionMonitor.isSessionDead() && !isPastExpiry();
